import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@ublend-npm/aulaui-next-web/Avatar';

import ParticipantSecondaryAction from './ParticipantSecondaryAction';
import ParticipantDescription from './ParticipantDescription.container';
import { EducatorInSpaces } from './ParticipantsTab/AddUserDialog/types';

import { ListItem, ListItemText, ListItemAvatar } from './ListItem.styled';

const ParticipantListItem = ({
  userId,
  avatar,
  fullName,
  email,
  isCurrentUser,
  participantIsEducator,
  isCreatingConversation,
  onMessage,
  onRemove,
  showActionButtons,
  educatorInSpaces,
  currentUserIsEducator,
}) => (
  <ListItem alignItems="flex-start">
    <ListItemAvatar>
      <Avatar size="large" name={fullName} src={avatar} />
    </ListItemAvatar>
    <ListItemText
      primary={fullName}
      secondary={
        <ParticipantDescription
          userId={userId}
          educatorInSpaces={educatorInSpaces}
        />
      }
    />
    <ListItemText primary={email} isEmail />
    {showActionButtons ? (
      <ParticipantSecondaryAction
        isCurrentUser={isCurrentUser}
        currentUserIsEducator={currentUserIsEducator}
        isEducator={participantIsEducator}
        isCreatingConversation={isCreatingConversation}
        onMessage={onMessage}
        onRemove={onRemove}
      />
    ) : null}
  </ListItem>
);

ParticipantListItem.propTypes = {
  fullName: PropTypes.string,
  avatar: PropTypes.string,
  userId: PropTypes.string,
  email: PropTypes.string,
  isCurrentUser: PropTypes.bool,
  currentUserIsEducator: PropTypes.bool.isRequired,
  participantIsEducator: PropTypes.bool,
  isCreatingConversation: PropTypes.bool,
  onMessage: PropTypes.func,
  onRemove: PropTypes.func,
  showActionButtons: PropTypes.bool,
  educatorInSpaces: PropTypes.arrayOf(EducatorInSpaces),
};

ParticipantListItem.defaultProps = {
  avatar: null,
  fullName: '',
  email: '',
  isCurrentUser: false,
  participantIsEducator: false,
  isCreatingConversation: false,
  userId: '',
  showActionButtons: true,
  onRemove: () => {},
  onMessage: () => {},
  educatorInSpaces: null,
};

export default ParticipantListItem;
